document.addEventListener('DOMContentLoaded', function () {
    // Function to set up button functionality for a video
    function setupVideoButtons(videoId) {
        var video = document.getElementById(videoId);
        var playBtn = document.querySelector('.playBtn[data-video-id="' + videoId + '"]');
        var pauseBtn = document.querySelector('.pauseBtn[data-video-id="' + videoId + '"]');
        var replayBtn = document.querySelector('.replayBtn[data-video-id="' + videoId + '"]');
        var muteBtn = document.querySelector('.muteBtn[data-video-id="' + videoId + '"]');
        var unmuteBtn = document.querySelector('.unmuteBtn[data-video-id="' + videoId + '"]');

        playBtn.addEventListener('click', function () {
            video.play();
            playBtn.classList.add('hidden');
            pauseBtn.classList.remove('hidden');
        });

        pauseBtn.addEventListener('click', function () {
            video.pause();
            playBtn.classList.remove('hidden');
            pauseBtn.classList.add('hidden');
        });

        replayBtn.addEventListener('click', function () {
            video.currentTime = 0;
            video.play();
            playBtn.classList.add('hidden');
            pauseBtn.classList.remove('hidden');
            document.querySelector('.rpmblock--cover-video__video').style.display = 'block';
            document.querySelector('#fade-div').style.opacity = '0';
        });

        muteBtn.addEventListener('click', function () {
            video.muted = false;
            muteBtn.classList.add('hidden');
            unmuteBtn.classList.remove('hidden');
        });

        unmuteBtn.addEventListener('click', function () {
            video.muted = true;
            muteBtn.classList.remove('hidden');
            unmuteBtn.classList.add('hidden');
        });
    }

    // Set up buttons for the first video
    setupVideoButtons('myVideo');

    // Set up buttons for the second video
    setupVideoButtons('myVideo2');
});